<template>
    <v-stepper v-model="step">
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Lakukan Pembayaran</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">Upload bukti pembayaran</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">Menunggu akun aktif</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <payment-information-step
                @nextStep="step = 2"
                step="1"
                :payment="payment"
            ></payment-information-step>

            <proof-step
                @nextStep="step = 3"
                @prevStep="step = 1"
                step="2"
            >
            </proof-step>

            <post-waiting step="3"></post-waiting>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import PostWaiting from '@/components/dashboard/payment/PostWaiting'
import PaymentInformationStep from './PaymentInformationStep'
import ProofStep from './ProofStep'

export default {
    props: {
        payment: {
            type: Object,
        }
    },

    components: {
        PostWaiting,
        PaymentInformationStep,
        ProofStep,
    },

    data() {
        return {
            step: 1,
        }
    },

    created() {
        if (this.payment.payment_proof) {
            this.step = 3
        }
    }
}
</script>
